import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { EyeFill, EyeSlashFill, Search } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import { searchCallHistory } from "../store/api/CustomerApi";
import BihamtaTable from "../../Components/BihamtaTable";

const CallHistory = () => {
    const [showFilters, setShowFilters] = useState(true);
    const [dataList, setDataList] = useState({Data:[]});
    const searchData = useRef({});
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilters(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilters(true);
        }
    }
    function search(e){
        if(e?.key && e.key !=="Enter")
        {
            return;
        }
        const pCallDate = document.getElementsByName("CallDate")[0];
        if(pCallDate.value === "")
        {
            searchData.current.CallDate = null;
        }
        const pToDate = document.getElementsByName("ToDate")[0];
        if(pToDate.value === "")
        {
            searchData.current.ToDate = null;
        }
        searchData.current.CallerType = " ";
        searchCallHistory(searchData.current, setDataList);
    }
    const tableCols =[
        {colTitle:"ردیف", colName:"RowNumber"},
        {colTitle:"تماس گیرنده", colName:"CallerName"},
        {colTitle:"کاربر داخلی", colName:"UserName"},
        {colTitle:"شماره تماس", colName:"CallNumber"},
        {colTitle:"تاریخ و ساعت تماس", colName:"PCallDate"}
    ]
    useEffect(() => {
        document.body.classList = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card className="card">
                <Card.Header className="headerStyle">تاریخچه تماس ها</Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <Row id="divFilters" className="rowBorder">
                        <div className="rowTitle">
                            فیلترهای جستجو
                            &nbsp;
                            {showFilters && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                            {!showFilters && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                        </div>
                        <Col md={2} className="form-group">
                            <label>از تاریخ: </label>
                            <DatePicker isGregorian={false} timePicker={false} className="form-control" name='CallDate'
                                onChange={value => { searchData.current.CallDate = value.local("en").format("YYYY-MM-DD") }} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>تا تاریخ: </label>
                            <DatePicker isGregorian={false} timePicker={false} className="form-control" name='ToDate'
                                onChange={value => { searchData.current.ToDate = value.local("en").format("YYYY-MM-DD") }} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>شماره تماس: </label>
                            <Form.Control onChange={e => searchData.current.CallNumber = e.target.value} onKeyDown={search}/>
                        </Col>
                        <Col md={2} className="form-group">
                            <label>نام تماس گیرنده: </label>
                            <Form.Control onChange={e => searchData.current.CallerName = e.target.value} onKeyDown={search}/>
                        </Col>
                        <Col md={2} className="form-group">
                            <label>کاربر داخلی: </label>
                            <Form.Control onChange={e => searchData.current.UserName = e.target.value} onKeyDown={search}/>
                        </Col>
                    </Row>
                    <Button className="group-Btn-large mb-2 mt-1" onClick={search}><Search size={18} />&nbsp; جسـتجـو&nbsp;</Button>
                    <BihamtaTable columns={tableCols} dataList={dataList} fixedHeight className="mt-0"/>
                </Card.Body>
            </Card>
        </div>
    )
}
export default CallHistory;